module.exports = __webpack_public_path__ + "img/C-info-03.e658964d.png";